interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  /** 顶部小眉批（monospace 大写），如 "订单中心 · ORDERS"。非必填。*/
  kicker?: string;
  /**
   * Optional badge/chip rendered next to the title — used for context cues
   * (e.g. <FactoryContextBadge /> showing which factory's slice the page
   * is filtered to). Single factory users / unscoped pages just leave it
   * unset; the layout falls back to title-only.
   */
  contextBadge?: React.ReactNode;
}

/**
 * 页面主标题区。
 *
 * 设计系统（DESIGN.md §7.3 / §10）：
 * - 不再用白色圆角卡片承载，改用 1px birch-200 下边框 + 透底
 *   气质更像工艺图纸的章节分隔，不是 SaaS Dashboard 的卡片
 * - 标题 text-2xl (28/36)，副标 text-sm oak-500
 * - 可选 kicker 小眉批用 monospace 大写
 */
export default function PageHeader({ title, subtitle, actions, kicker, contextBadge }: PageHeaderProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-birch-200 pb-4 lg:flex-row lg:items-end lg:justify-between">
      <div className="min-w-0">
        {kicker ? (
          <div className="mb-1 font-mono text-2xs uppercase tracking-[0.15em] text-oak-500">
            {kicker}
          </div>
        ) : null}
        <div className="flex flex-wrap items-baseline gap-2">
          <h1 className="text-2xl font-semibold text-ironwood">{title}</h1>
          {contextBadge}
        </div>
        {subtitle ? <p className="mt-1 hidden text-sm text-oak-500 lg:block">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  );
}
